<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Recurring Work Orders Deletion"
    @on-hide="resetFormData"
  >
    <imports-form
      destructive-subtitle="This will delete the selected recurring work orders."
      @on-submit="createRecurringWorkOrdersDeletionImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Recurring Work Orders Deletion Template.xlsx"
              :file-provider="$importsAPI.getRecurringWorkOrdersDeletionTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'RecurringWorkOrdersImportsDeleteModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'recurring-work-orders-imports-delete-modal',
    };
  },
  methods: {
    createRecurringWorkOrdersDeletionImport(data, handleCreate) {
      handleCreate(this.$importsAPI.recurringWorkOrdersDeletionCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>